export function formatRegistrationNumber(registrationNumber) {
  if (!registrationNumber) return "";

  const digits = registrationNumber.replace(/\D/g, ""); // só números

  if (digits.length === 11) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  } else if (digits.length === 14) {
    return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  }

  return registrationNumber;
}